export default __webpack_public_path__ + "static/media/05AW2MAR66.7dfa1db8.jpg";